<app-navbar-style-one></app-navbar-style-one>

<!-- <div class="inner-banner inner-bg2">
    <div class="container">
        <div class="inner-content">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <div class="inner-banner-text">
                        <h3>The Beauty Shop</h3>
                        <ul>
                            <li><i class="flaticon-cursor"></i>40 Square Plaza, NJ, USA</li>
                            <li><i class="flaticon-telephone"></i> <a href="tel:+6(567)876543">+6(567)876543</a></li>
                            <li><i class="flaticon-email-1"></i> <a href="#">pilar@domain.com</a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="banner-rating">
                        <ul>
                            <li class="rating-star">
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <span>4 Review</span>
                            </li>
                            <li><a routerLink="/listing-details">4.9</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="banner-bottom">
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="banner-tag">
                        <ul>
                            <li><a routerLink="/listing-details"><i class="flaticon-favorite"></i>Book Now</a></li>
                            <li><a routerLink="/listing-details"><i class="flaticon-writing"></i> Add Review</a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6">
                    <div class="banner-profile">
                        <img src="assets/img/place-list/place-profile.png" alt="Images">
                        <h3>By, Alfred</h3>
                        <div class="banner-status">
                            <a routerLink="/listing-details"><h3>Open Now</h3></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="banner-list">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-7">
                    <ul class="list">
                        <li><a href="index.html">Home</a></li>
                        <li><i class='bx bx-chevron-right'></i></li>
                        <li class="active">The Beauty Shop</li>
                    </ul>
                </div>

                <div class="col-lg-6 col-md-5">
                    <ul class="social-link">
                        <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-pinterest-alt'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-youtube'></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div> -->


<div class="inner-banner inner-bg2">
    <div class="container">
        <div class="inner-content">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <div class="inner-banner-text">
                        <h3>Firma Legal Rodriguez & Asociados</h3>
                        <ul>
                            <li><i class="flaticon-cursor"></i>Calle Mayor 45, Madrid, España</li>
                            <li><i class="flaticon-telephone"></i> <a href="tel:+34(915)123456">+34(915)123456</a></li>
                            <li><i class="flaticon-email-1"></i> <a href="mailto:rodriguez@accioget.com">rodriguez@accioget.com</a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="banner-rating">
                        <ul>
                            <li class="rating-star">
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <span>25 Opiniones</span>
                            </li>
                            <li><a routerLink="/listing-details">4.8</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="banner-bottom">
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="banner-tag">
                        <ul>
                            <li><a routerLink="/appointment"><i class="flaticon-calendar"></i>Reservar Cita</a></li>
                            <li><a routerLink="/listing-details"><i class="flaticon-writing"></i> Añadir Opinión</a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6">
                    <div class="banner-profile">
                        <img src="assets/img/place-list/place-profile.png" alt="Foto">
                        <h3>Por, Juan Rodriguez</h3>
                        <div class="banner-status">
                            <a routerLink="/listing-details"><h3>Abierto Ahora</h3></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="banner-list">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-7">
                    <ul class="list">
                        <li><a href="index.html">Inicio</a></li>
                        <li><i class='bx bx-chevron-right'></i></li>
                        <li class="active">Firma Legal Rodriguez & Asociados</li>
                    </ul>
                </div>

                <div class="col-lg-6 col-md-5">
                    <ul class="social-link">
                        <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="listing-details-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="listing-details-wrap">
                    <div class="listing-category">
                        <ul>
                            <li><a routerLink="/firm-details"><i class="flaticon-touch"></i>DETALLES</a></li>
                            <li><a routerLink="/firm-gallery"><i class="flaticon-gallery"></i> GALERÍA</a></li>
                            <li><a routerLink="/firm-reviews"><i class="flaticon-writing"></i> OPINIONES</a></li>
                        </ul>
                        <h3><i class="flaticon-worldwide"></i> MAPA</h3>
                    </div>

                    <div class="listing-widget listing-widget-desc">
                        <h3 class="title">Descripción</h3>
                        <p> En nuestra firma legal, nos especializamos en proporcionar servicios jurídicos de alta calidad. Con años de experiencia, hemos ayudado a numerosos clientes a navegar a través de situaciones legales complejas.</p>
                        <p>Ya sea que necesite asesoramiento en materia de derecho laboral, inmobiliario o cualquier otro tipo de consulta legal, nuestro equipo de profesionales está aquí para ayudarle. Nuestro objetivo es lograr los mejores resultados posibles para nuestros clientes.</p>
                        <a routerLink="/firm-details" class="default-btn border-radius">Visitar Sitio Web <i class='bx bx-plus'></i></a>
                        <div class="listing-features">
                            <h3 class="features-title">Características del Despacho</h3>
                            <div class="row">
                                <div class="col-lg-3 col-md-3">
                                    <div class="features-card">
                                        <i class="flaticon-justice"></i>
                                        <h3>Asesoramiento Personalizado</h3>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-3">
                                    <div class="features-card">
                                        <i class="flaticon-book"></i>
                                        <h3>Biblioteca Legal</h3>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-3">
                                    <div class="features-card">
                                        <i class="flaticon-meeting"></i>
                                        <h3>Sala de Reuniones</h3>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-3">
                                    <div class="features-card">
                                        <i class="flaticon-coffee-cup"></i>
                                        <h3>Zona de Espera Confortable</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="listing-widget gallery-slider">
                        <h3 class="title">Galeria / Fotos</h3>

                        <div class="gallery-slider-area owl-carousel owl-theme">
                            <div class="Gallery-item">
                                <img src="assets/img/place-list/listing-details1.jpg" alt="Images">
                            </div>

                            <div class="Gallery-item">
                                <img src="assets/img/place-list/listing-details2.jpg" alt="Images">
                            </div>

                            <div class="Gallery-item">
                                <img src="assets/img/place-list/listing-details3.jpg" alt="Images">
                            </div>

                            <div class="Gallery-item">
                                <img src="assets/img/place-list/listing-details4.jpg" alt="Images">
                            </div>
                        </div>
                    </div>

                    <div class="listing-widget listing-map">
                        <h3 class="title">Ubicación</h3>

                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d735257.9205168115!2d-75.33502765384733!3d40.30050562979537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2a07dcfd9d0ce20e!2sUs%20Rt%2040%20%40%20Governors%20Sq%20Plaza%202!5e0!3m2!1sen!2sbd!4v1596709319151!5m2!1sen!2sbd"></iframe>
                    </div>

                    <div class="listing-widget">

                        <h3 class="title">Valoraciones - 2</h3>

                        <div class="listing-widget-review">
                            <ul>
                                <li class="rating-star">
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <span>Comentarios positivos</span>
                                </li>
                                <li><a routerLink="/firm-details">4.5</a></li>
                            </ul>
                        </div>

                        <div class="progressbar-area">
                            <div class="single-progressbar">
                                <h3>Profesionalidad</h3>
                                <div class="progressbar-count">
                                    <div class="progressbar-number pn-1">5.0</div>
                                    <div class="progressbar-circle pc-1"></div>
                                </div>
                            </div>

                            <div class="single-progressbar">
                                <h3>Accesibilidad</h3>
                                <div class="progressbar-count">
                                    <div class="progressbar-number pn-2">5.5</div>
                                    <div class="progressbar-circle pc-2"></div>
                                </div>
                            </div>

                            <div class="single-progressbar">
                                <h3>Tarifas</h3>
                                <div class="progressbar-count">
                                    <div class="progressbar-number pn-3">4.7</div>
                                    <div class="progressbar-circle pc-3"></div>
                                </div>
                            </div>

                            <div class="single-progressbar">
                                <h3>Atención al cliente</h3>
                                <div class="progressbar-count">
                                    <div class="progressbar-number pn-4">4.5</div>
                                    <div class="progressbar-circle pc-4"></div>
                                </div>
                            </div>
                        </div>


                        <div class="listing-comment">
                            <ul>
                                <li>
                                    <img src="assets/img/firm-profile/firm-profile1.png" alt="Image">
                                    <div class="content">
                                        <h3>Carlos Martinez</h3>
                                        <span>12 de Enero, 2023</span>
                                        <p>El equipo de AccioGest ha demostrado un nivel de profesionalidad y compromiso inigualable. Realmente comprenden las necesidades del cliente y ofrecen soluciones a medida.</p>
                                        <div class="comment-rating">
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                            <span>4.5</span>
                                        </div>
                                        <a routerLink="/firm-details">Responder</a>
                                        <div class="view-list">
                                            Opinión útil 23
                                        </div>
                                    </div>
                                </li>

                                <li>
                                    <img src="assets/img/firm-profile/firm-profile2.png" alt="Image">
                                    <div class="content">
                                        <h3>Sofía Ruiz</h3>
                                        <span>12 de Julio, 2023</span>
                                        <p>Gracias a AccioGest pude resolver un problema legal complicado. Me acompañaron en todo el proceso y siempre sentí que estaban de mi lado.</p>
                                        <div class="comment-rating">
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                            <span>4.5</span>
                                        </div>
                                        <a routerLink="/firm-details">Responder</a>
                                        <div class="view-list">
                                            Opinión útil 23
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                    </div>

                    <div class="listing-widget progressbar-area-title">
                        <h3 class="title">Añadir Valoración</h3>

                        <div class="progressbar-area progressbar-bg">
                            <div class="single-progressbar">
                                <h3>Profesionalidad</h3>

                                <div class="progressbar-count">
                                    <div class="progressbar-number pn-1">5.0</div>
                                    <div class="progressbar-circle pc-1"></div>
                                </div>
                            </div>

                            <div class="single-progressbar">
                                <h3>Comunicación</h3>

                                <div class="progressbar-count">
                                    <div class="progressbar-number pn-2">4.8</div>
                                    <div class="progressbar-circle pc-2"></div>
                                </div>
                            </div>

                            <div class="single-progressbar">
                                <h3>Coste</h3>

                                <div class="progressbar-count">
                                    <div class="progressbar-number pn-3">4.5</div>
                                    <div class="progressbar-circle pc-3"></div>
                                </div>
                            </div>

                            <div class="single-progressbar">
                                <h3>Resolución</h3>

                                <div class="progressbar-count">
                                    <div class="progressbar-number pn-4">4.7</div>
                                    <div class="progressbar-circle pc-4"></div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="listing-widget-contact">
                        <div class="listing-contact-title">
                            <div class="row">
                                <div class="col-lg-6 col-md-6">
                                    <div class="listing-widget-mail">
                                        <i class="flaticon-email-2"></i>
                                        <div class="content">
                                            <h3>Confidencialidad Garantizada</h3>
                                            <span>Su correo electrónico está protegido con nosotros.</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 text-end">
                                    <div class="listing-contact-review">
                                        <ul>
                                            <li class="rating-star">
                                                <i class='bx bxs-star'></i>
                                                <i class='bx bxs-star'></i>
                                                <i class='bx bxs-star'></i>
                                                <i class='bx bxs-star'></i>
                                                <i class='bx bxs-star'></i>
                                                <span>Su Valoración</span>
                                            </li>
                                            <li><a href="#">4.5</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="contact-form">
                            <form id="contactForm">
                                <div class="row">
                                    <div class="col-lg-6 col-sm-6">
                                        <div class="form-group">
                                            <i class='bx bx-user'></i>
                                            <input type="text" name="name" id="name" class="form-control" required placeholder="Su Nombre*">
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-sm-6">
                                        <div class="form-group">
                                            <i class='bx bx-envelope'></i>
                                            <input type="email" name="email" id="email" class="form-control" required placeholder="Correo Electrónico*">
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12">
                                        <div class="form-group">
                                            <i class='bx bx-message'></i>
                                            <textarea name="message" class="form-control" id="message" cols="30" rows="8" required placeholder="Su Mensaje"></textarea>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12">
                                        <button type="submit" class="default-btn border-radius">Enviar Mensaje <i class='bx bx-send'></i></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-lg-4">
                <div class="listing-details-side">
                    <div class="listing-widget-side">
                        <h3 class="title">Solicitar Consulta</h3>

                        <div class="listing-Booking-form">
                            <form>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <i class='bx bx-user'></i>
                                            <input type="text" name="name" id="name" class="form-control" required placeholder="Su Nombre*">
                                        </div>
                                    </div>

                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <i class='flaticon-email-2'></i>
                                            <input type="email" name="email" id="email" class="form-control" required placeholder="Correo Electrónico*">
                                        </div>
                                    </div>

                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <i class='bx bx-phone'></i>
                                            <input type="text" name="phone_number" id="phone_number" required class="form-control" placeholder="Número de Teléfono">
                                        </div>
                                    </div>

                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <i class="flaticon-calendar"></i>
                                            <input type="text" class="form-control" placeholder="Fecha y Hora">
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12">
                                        <div class="form-group">
                                            <i class='bx bx-message'></i>
                                            <textarea name="message" class="form-control" id="message" cols="30" rows="8" required placeholder="Describa su Caso"></textarea>
                                        </div>
                                    </div>

                                    <!-- Puedes agregar servicios adicionales si la firma legal ofrece otros servicios que los clientes pueden añadir a su solicitud -->

                                </div>

                                <!-- Esta parte puede ser omitida o adaptada según lo que se desee mostrar en términos de costos o tarifas. -->
                                <h3 class="price-rate">Tarifa Estimada <span>$50.00</span></h3>

                                <div class="col-lg-12 col-md-12 text-center">
                                    <button type="submit" class="default-btn border-radius">Enviar Solicitud <i class='bx bx-send'></i></button>
                                </div>
                            </form>
                        </div>
                    </div>


                    <div class="listing-widget-side">
                        <h3 class="title">Horario de Atención</h3>

                        <ul class="listing-widget-list">
                            <li>Lunes <span>9:00 AM - 6:00 PM</span></li>
                            <li>Martes <span>9:00 AM - 6:00 PM</span></li>
                            <li>Miércoles <span>9:00 AM - 6:00 PM</span></li>
                            <li>Jueves <span>9:00 AM - 6:00 PM</span></li>
                            <li>Viernes <span>9:00 AM - 6:00 PM</span></li>
                            <li>Sábado <span>Cerrado</span></li>
                            <li>Domingo <span>Cerrado</span></li>
                        </ul>
                    </div>

                    <div class="listing-widget-side">
                        <h3 class="title">Contacto</h3>

                        <ul class="listing-widget-list">
                            <li>Dirección : <span> Calle 27, Brooklyn NY, USA</span></li>
                            <li>Teléfono : <span><a href="tel:+3(567)347654">+3(567)347654</a></span></li>
                            <li>Correo : <span><a href="mailto:pilar@listing.com">pilar@listing.com</a></span></li>
                            <li>Sitio Web : <span> <a href="#">https://pilar.com</a></span></li>
                        </ul>

                        <ul class="social-link">
                            <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                        </ul>
                    </div>


                    <div class="listing-widget-side">
                        <h3 class="title">Rango de Tarifas</h3>
                        <h3 class="price-title">Tarifa : <span>$ 1,000.00 - $ 10,000.00</span></h3>
                    </div>

                    <div class="listing-widget-side">
                        <h3 class="title">Atendido por:</h3>

                        <div class="listing-side-host">
                            <img src="assets/img/legal/lawyer-profile.png" alt="Imagen de Abogado">
                            <h3>Lic. Roberto Martínez</h3>
                            <span>20 CASOS GANADOS</span>
                        </div>

                        <ul class="side-host-list">
                            <li><a href="#"><i class='bx bxs-user'></i></a></li>
                            <li><a href="#"><i class='bx bx-envelope'></i></a></li>
                            <li> <span>¡Contáctalo Ahora!</span></li>
                        </ul>
                    </div>

                    <div class="listing-widget-side">
                        <h3 class="title">Etiquetas Relacionadas</h3>

                        <ul class="listing-side-tag">
                            <li><a href="#">#DerechoFamiliar</a></li>
                            <li><a href="#"><b>#DerechoPenal</b></a></li>
                            <li><a href="#">#DerechoLaboral</a></li>
                            <li><a href="#"><b>#DerechoCivil</b></a></li>
                            <li><a href="#">#AsesoríaLegal</a></li>
                            <li><a href="#">#Litigio</a></li>
                        </ul>
                    </div>


                    <!-- <div class="listing-widget-side listing-blog-post">
                        <h3 class="title">News Tags</h3>

                        <ul class="listing-widget-post">
                            <li>
                                <div class="img">
                                    <img src="assets/img/place-list/listing-blog.jpg" alt="Images">
                                </div>

                                <div class="content">
                                    <span>Hotel</span>
                                    <h4>Real Estate Is Being</h4>
                                    <p><i class="flaticon-cursor"></i> 8 BRIGHT ST, JERSEY CITY 07302, USA</p>
                                </div>
                            </li>
                            <li>
                                <div class="img">
                                    <img src="assets/img/place-list/listing-blog2.jpg" alt="Images">
                                </div>

                                <div class="content">
                                    <span>Residence</span>
                                    <h4>Place Of Expectation</h4>
                                    <p><i class="flaticon-cursor"></i> 70 BRIGHT ST NEW YORK USA</p>
                                </div>
                            </li>
                            <li>
                                <div class="img">
                                    <img src="assets/img/place-list/listing-blog3.jpg" alt="Images">
                                </div>

                                <div class="content">
                                    <span>Place</span>
                                    <h4>Came In The Place</h4>
                                    <p><i class="flaticon-cursor"></i> 78 HillStreet ST NEW YORK USA</p>
                                </div>
                            </li>
                        </ul>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>
